import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { DEFAULT_LANGUAGE } from '../../config/languages';

/**
 * LanguageLink Component
 * 
 * A wrapper around React Router's Link component that automatically
 * prepends the current language code to all internal links.
 * 
 * Usage: Replace <Link to="/about"> with <LanguageLink to="/about">
 */
const LanguageLink = ({ to, children, ...props }) => {
    const { lang } = useParams();
    const location = useLocation();

    // Helper to get lang from path if params are missing (e.g. inside Header)
    const getLangFromPath = () => {
        const match = location.pathname.match(/^\/([a-z]{2})(\/|$)/);
        return match ? match[1] : DEFAULT_LANGUAGE;
    };

    const currentLang = lang || getLangFromPath();

    // If the link already starts with a language code, use it as-is
    if (to.match(/^\/[a-z]{2}(\/|$)/)) {
        return <Link to={to} {...props}>{children}</Link>;
    }

    // If it's an external link or hash link, use it as-is
    if (to.startsWith('http') || to.startsWith('#')) {
        return <Link to={to} {...props}>{children}</Link>;
    }

    // Prepend the current language code
    const languageAwarePath = `/${currentLang}${to.startsWith('/') ? to : '/' + to}`;

    return <Link to={languageAwarePath} {...props}>{children}</Link>;
};

export default LanguageLink;
